import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Tabs = ({ children, className, activeIndex, onTabChange  }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(0);
  const isControlled = activeIndex !== undefined;
  const currentActiveTab = isControlled ? activeIndex : internalActiveTab;

  const handleTabClick = index => {
     if (onTabChange) {
      onTabChange(index);
    } else {
      setInternalActiveTab(index);
    }
  };

  return (
    <>
      <ul
        className={`nav nav-pills nav-justified  mb-3 d-sm-flex d-block ${className}`}
        role="tablist"
      >
        {React.Children.map(children, (child, index) => (
          <li className="nav-item">
            <Link
              className={`nav-link text-break ${child.props.linkClassName} ${index === currentActiveTab ? 'active' : ''}`}
              data-bs-toggle="tab"
              role="tab"
              aria-current="page"
              to="#employee-vertical"
              aria-selected="true"
              onClick={() => handleTabClick(index)}
            >
              <i className={`${child.props.iconName} me-2 align-middle d-inline-block`} />
              {child.props.title}
            </Link>
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {React.Children.map(children, (child, index) =>
          index === currentActiveTab ? (
            <div className="tab-pane active" role="tabpanel">
              {child}
            </div>
          ) : null,
        )}
      </div>
    </>
  );
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const Tab = ({ children, className }) => {
  return <div className={`tab ${className}`}>{children}</div>;
};

Tab.propTypes = {
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  linkClassName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export { Tabs, Tab };
